import type {SerializedGraphNode} from "@cm/graph-v3"
import {deserializeGraphNode} from "@cm/graph-v3"
import {FlattenPriceList} from "#pricing/nodes/flatten-pricelist"

export function deserializePriceGraph(graph: SerializedGraphNode): FlattenPriceList {
    const result = deserializeGraphNode(graph, "pricing")
    if (!(result instanceof FlattenPriceList)) throw new Error(`Deserialized node is not a FlattenPriceList (got ${result.nodeClass})`)
    return result
}
